module.exports = __webpack_public_path__ + "img/pic1.41216020.png";